import { render } from "./subholding-companies-modal.vue?vue&type=template&id=6d66af50"
import script from "./subholding-companies-modal.vue?vue&type=script&lang=js"
export * from "./subholding-companies-modal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__